import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { BlogPost } from '../../../../shared/models/blog.model';
import { BLOG_COPY } from '../../constants/blog.constants';

@Component({
  selector: 'app-article-author-card',
  templateUrl: './article-author-card.component.html',
  styleUrl: './article-author-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class ArticleAuthorCardComponent {
  post = input.required<BlogPost>();

  protected readonly copy = BLOG_COPY;
}
